import "./Navbar.css";
import { useRef, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../assets/images/logos/Logo1.png";
import LogoNoText from "../../assets/images/logos/Logo1_notext.png";
import { useTheme, themes } from "../../contexts/Theme.context";
import { IoMoonSharp, IoSunny } from "react-icons/io5";
import { useTranslation } from "react-i18next";

export const Navbar = () => {
  const navRef1 = useRef();
  const [active, setActive] = useState("");
  const { pathname } = useLocation();
  const { theme, toggleTheme } = useTheme();
  const { i18n, t } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);
  const [prevScrollPos, setPrevScrollPos] = useState(window.scrollY);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    let path = pathname.replace("/", "");
    setActive(`${path}`);

    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const scrollingUp = currentScrollPos < prevScrollPos;

      if (currentScrollPos > 200 && !scrollingUp) setScrolled(true);
      else if (scrollingUp) setScrolled(false);

      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [pathname, prevScrollPos]);

  const languages = {
    en: { nativeName: "English" },
    nl: { nativeName: "Dutch" },
    fr: { nativeName: "French" },
  };

  const toggleMobileMenu = () => {
    navRef1.current.classList.toggle("open");
  };

  const handleLanguageChange = (event) => {
    const language = event.target.value;
    setSelectedLanguage(language.nativeName);
    i18n.changeLanguage(language);
  };

  return (
    <header>
      <div id="brand">
        <Link to="/">
          <img
            className={scrolled ? "logoIconNoText" : "logoIcon"}
            src={scrolled ? LogoNoText : Logo}
            alt="VH BuildUp! Logo"
          />
        </Link>
      </div>
      <nav className="nav">
        <ul className="listNav">
          <li className="listItemNav">
            <Link to="/">
              <span className={active === "" ? "activeNav" : ""}>
                {t("navbar.home")}
              </span>
            </Link>
          </li>
          <li className="listItemNav">
            <Link to="/project-management">
              <span
                className={active === "project-management" ? "activeNav" : ""}
              >
                {t("navbar.project")}
              </span>
            </Link>
          </li>
          <li className="listItemNav">
            <Link to="/realizations">
              <span className={active === "realizations" ? "activeNav" : ""}>
                {t("navbar.realizations")}
              </span>
            </Link>
          </li>
          <li className="listItemNav">
            <Link to="/contact">
              <span className={active === "contact" ? "activeNav" : ""}>
                {t("navbar.contact")}
              </span>
            </Link>
          </li>
          <li style={{ display: "flex" }}>
            <button
              className="themeButton"
              type="button"
              onClick={toggleTheme}
              aria-label="Switch Theme Button"
            >
              {theme === themes.dark ? (
                <IoSunny size={20} />
              ) : (
                <IoMoonSharp size={20} />
              )}
            </button>
          </li>
          <li style={{ display: "flex" }}>
            <select
              className="themeButton"
              value={selectedLanguage}
              onChange={handleLanguageChange}
            >
              {Object.keys(languages).map((locale) => (
                <option key={locale.id} value={locale}>
                  {locale.toUpperCase()}
                </option>
              ))}
            </select>
          </li>
        </ul>
      </nav>
      <div className="hamburger-container">
        <button
          className="themeButton nav-container-button"
          type="button"
          onClick={toggleTheme}
          aria-label="Switch Theme Button"
        >
          {theme === themes.dark ? (
            <IoSunny size={20} />
          ) : (
            <IoMoonSharp size={20} />
          )}
        </button>
        <select
          className="themeButton nav-container-button"
          value={selectedLanguage}
          onChange={handleLanguageChange}
        >
          {Object.keys(languages).map((locale) => (
            <option key={locale.id} value={locale}>
              {locale.toUpperCase()}
            </option>
          ))}
        </select>
        <div id="hamburger-icon" ref={navRef1} onClick={toggleMobileMenu}>
          <div className="bar1"></div>
          <div className="bar2"></div>
          <div className="bar3"></div>
          <ul
            className={`mobile-menu listNav ${scrolled ? "scrolled-menu" : ""}`}
          >
            <li className="listItemNav">
              <Link to="/">
                <span className={active === "" ? "activeNav" : ""}>
                  {t("navbar.home")}
                </span>
              </Link>
            </li>
            <li className="listItemNav">
              <Link to="/project-management">
                <span
                  className={active === "project-management" ? "activeNav" : ""}
                >
                  {t("navbar.project")}
                </span>
              </Link>
            </li>
            <li className="listItemNav">
              <Link to="/realizations">
                <span className={active === "realizations" ? "activeNav" : ""}>
                  {t("navbar.realizations")}
                </span>
              </Link>
            </li>
            <li className="listItemNav">
              <Link to="/contact">
                <span className={active === "contact" ? "activeNav" : ""}>
                  {t("navbar.contact")}
                </span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};
